'use strict';

import dispatcher from '../dispatcher';
import {isIE, isSafari} from 'a-utils';
import scrollStore from "../scroll/scroll.store";
import resizeStore from "../resize/resize.store";
import {gsap} from "gsap";

function _supportsHEVCAlpha() {
    const navigator = window.navigator;
    const hasMediaCapabilities = !!(navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo)
    return isSafari && hasMediaCapabilities
}


class videoViewComponent extends HTMLElement {
    constructor() {
        super();

        this._playForever = this.dataset.playForever || false

        this.srcMov = this.dataset.srcMov;
        this.srcWebm = this.dataset.srcWebm;
        this.video = this.querySelector('video');
        this._videoType = _supportsHEVCAlpha() ? this.srcMov : this.srcWebm;

        this.onResize = (e) => this._resize(e);
        this.onScroll = (e) => this._scroll(e);
    }

    connectedCallback() {
        if (!isIE()) {
            if(this._videoType) {
                this.video.src = this._videoType;
                this.video.addEventListener('canplay', this._loadVideo);
            } else {
                console.error('Необходимо оба формата: webm и mov')
            }
        }

        this.addEventListener('mouseenter', this._onHover);
        this.addEventListener('mouseleave', this._onBlur);

        resizeStore.eventEmitter.addListener(this.onResize);
        scrollStore.eventEmitter.addListener(this.onScroll);
        window.addEventListener('scroll', this.onScroll);
    }

    _loadVideo() {
        this.classList.add('no-bg')
    }

    disconnectedCallback() {
        this.video.removeEventListener('canplay', this._loadVideo);

        this.removeEventListener('mouseenter', this._onHover);
        this.removeEventListener('mouseleave', this._onBlur);

        resizeStore.eventEmitter.removeListener(this.onResize);
        scrollStore.eventEmitter.removeListener(this.onScroll);
        window.removeEventListener('scroll', this.onScroll);
    }


    _scroll() {

    }

    _resize(e) {

    }




    _onHover() {
        if (!this._playForever)
            this.video.play()
    }
    _onBlur() {
        if (!this._playForever)
            this.video.pause()
    }


}


window.customElements.define('video-view', videoViewComponent);
